/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import React from "react";
import PropTypes from "prop-types";
import NumberOfSearchResultsCss from "./NumberOfSearchResults.css";
import { FormattedMessage } from "react-intl";
import { isCurrentDeviceMobile, isCurrentDeviceTablet } from "dc-preview-utils/src/Utils/DeviceUtils";
import { getIsInPlaceMode } from "selectors/viewModeSelectors";
import { isSinglePageMode } from "selectors/documentSelectors";
import * as stores from "stores";
import { APP_THEMES } from "constants/enums";

class NumberOfSearchResultsInDocument extends React.Component {
  render() {
    let style = this.props.useModernViewer
      ? {
          color: this.props.currentTheme === APP_THEMES.DARK ? "#B9B9B9" : "#333333",
          textAlign: "left",
          letterSpacing: "0"
        }
      : {};
    if (isCurrentDeviceMobile() || isCurrentDeviceTablet()) {
      style.fontSize = "16px";
    }
    if (this.props.themeColor === "dark") {
      style.color = "#cdcdcd";
    }

    if (!getIsInPlaceMode(stores)) {
      style.minWidth = this.props.useModernViewer ? "33px" : "75px";
    } else {
      if (!this.props.useModernViewer) {
        style.paddingTop = "5px";
      }
    }

    if (this.props.useModernViewer && isSinglePageMode(stores)) {
      style.paddingRight = "16px";
      style.paddingLeft = "16px";
    }

    return (
      <div className={NumberOfSearchResultsCss.NumberOfSearchResults} style={style} data-testid="search-results">
        <FormattedMessage
          id="find.numResults"
          values={{
            currentResult: this.props.indexOfCurrentSearchResult,
            totalResults: this.props.numberOfSearchResultsInDocument
          }}
        />
      </div>
    );
  }
}

export { NumberOfSearchResultsInDocument };
